module.exports = __webpack_public_path__ + "img/shuangdousha.fca7f77e.jpg";